import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-data-query",
  "use": "icon-data-query-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-data-query\"><path d=\"M819.2 898.048H204.8c-42.496 0-76.8-34.304-76.8-76.8v-219.136c0-14.336 11.264-25.6 25.6-25.6s25.6 11.264 25.6 25.6v219.136c0 14.336 11.264 25.6 25.6 25.6h614.4c14.336 0 25.6-11.264 25.6-25.6v-614.4c0-14.336-11.264-25.6-25.6-25.6h-192.512c-14.336 0-25.6-11.264-25.6-25.6s11.264-25.6 25.6-25.6H819.2c42.496 0 76.8 34.304 76.8 76.8v614.4c0 42.496-34.304 76.8-76.8 76.8z\" p-id=\"11118\" /><path d=\"M730.624 691.2l-218.112-218.112H512c29.696-36.864 48.128-83.456 48.128-134.144a216.064 216.064 0 1 0-216.064 216.064c49.664 0 95.232-17.408 131.584-46.08 0 0 0 0.512 0.512 0.512l218.112 218.112c9.728 9.728 25.6 9.728 35.328 0l1.024-1.024c9.728-10.24 9.728-26.112 0-35.328zM344.064 503.296c-91.136 0-164.864-73.728-164.864-164.864 0-91.136 73.728-164.864 164.864-164.864 91.136 0 164.864 73.728 164.864 164.864 0 90.624-73.728 164.864-164.864 164.864z\" p-id=\"11119\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/data-query.svg
// module id = VioT
// module chunks = 36